$("._toggle-menu").click(function () {
    $(".header").toggleClass("_open")
    $("body").toggleClass("fixed-body")
})

$(".header-contacts__show").click(function () {
    $(".header-contacts").toggleClass("_open")
})

$(".nav-item__show").click(function () {
    $(this).parents(".nav-item").addClass("_open")
})

$(".nav-item__back").click(function () {
    $(this).parents(".nav-item").removeClass("_open")
})

$(".header-search .fg input").on("input",function () {
    let val = $(this).val()
    if(val.length > 0){
        $(".header").addClass("_open-search")
    }else{
        $(".header").removeClass("_open-search")
    }
})

$("._toggle-catalog").click(function () {
    $(".header").toggleClass("_open-catalog")

    if(window.innerWidth<=992){
        $("body").toggleClass("fixed-body")
    }
})

$(".slider").click(function () {
    $(".header").removeClass("_open-catalog")
    $("body").removeClass("fixed-body")
})

$(document).mouseup( function(e){
    let div = $( ".header-catalog__inner" );
    if ( !div.is(e.target)
        && div.has(e.target).length === 0 ) {
        if($(".header").hasClass("_open-search")){
            $(".header").removeClass("_open-search")
        }
    }
});

$(document).mouseup( function(e){
    let div = $( ".header-search" );
    if ( !div.is(e.target)
        && div.has(e.target).length === 0 ) {
        if($(".header").hasClass("_open-catalog") && window.innerWidth>992){
            $(".header").removeClass("_open-catalog")
        }
    }
});

$(document).mouseup( function(e){
    let div = $( ".header-contacts" );
    if ( !div.is(e.target)
        && div.has(e.target).length === 0 ) {
        if($(div).hasClass("_open")){
            $(div).removeClass("_open")
        }
    }
});

$(".menu-item__show").mouseover(function () {
    $(".menu-item").removeClass("_open")
    $(".menu-item").removeClass("_open-desktop")
    $(this).parents(".menu-item").addClass("_open")
})

$(".menu-item__show").click(function () {
    $(".menu-item").removeClass("_open")
    $(this).parents(".menu-item").addClass("_open")
})

$(".menu-item__close").click(function () {
    $(this).parents(".menu-item").removeClass("_open")
})
